import {createContext} from "react";
import {IAcademicYearContext} from "../types/academicYear.interface";

// ? The selected academic year is panel-wide state: it is mounted once by components/Layout, above every screen,
// ? so a list screen only has to read it and add it to its query key.
const AcademicYear = createContext<IAcademicYearContext>({});

export default AcademicYear;
